import { Suspense, useState } from "react";
import FormularioBusquedaTablaDesarrollo from "../components/formularioBusquedaTablaDesarrollo";
import { Box, Paper } from "@mui/material";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import ModalGeneracionTablaDesarrollo from "../components/modalGenTablaDesarrollo";
import { FormularioTablaDesarrolloDto } from "../models/formularioTablaDesarrollo";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";
import UseTablaDesarrollo from "../hooks/useTablaDesarrollo";
import { useToast } from "../../../../hooks/useToast";
import { UpdateTablaDesarrollo } from "../models/updateTablaDesarrollo";
import { useNavigate } from 'react-router-dom';

export default function TablaDesarrollo(){

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Maestros', url: `/maestros` },
        { label: 'Tablas de desarrollo', active: true },
    ]

    const { addToast } = useToast();
    const { generarTabla, obtenerTabla, actualizarTabla, eliminarTabla } = UseTablaDesarrollo();
    const navigate = useNavigate();

    const [idToUpdate, setIdToUpdate] = useState<number>(0);

    const [nombreTabla, setNombreTabla] = useState<string>('');

    const onCreate = async (formulario: FormularioTablaDesarrolloDto) => {
        const response = await generarTabla(formulario);
        if (response.status === 200 || response.status === 201){
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: response.data.message,
            });
            setShowFormModal(false);
            setKey(key + 1);
        }
    }

    const onUpdate = async (id?: number | null) => {
        if (id){
            const response = await obtenerTabla(id);
            if (response.status === 200){
                setIdToUpdate(id);
                setTablaSeleccionada(response.data);
                setShowFormModal(true);
            }
        }
    }

    const onUpdateConfirm = async (formulario: FormularioTablaDesarrolloDto) => {
        if (formulario.fechaProtocolizacion && formulario.numeroProtocolizacion 
            && formulario.numeroRepertorio && formulario.notaria){
                const updateFormulario : UpdateTablaDesarrollo = {
                    fechaProtocolizacion: formulario.fechaProtocolizacion,
                    numeroProtocolizacion: formulario.numeroProtocolizacion,
                    numeroRepertorio: formulario.numeroRepertorio,
                    notaria: formulario.notaria
                }
                const response = await actualizarTabla(updateFormulario, idToUpdate);
                if (response.status === 200 || response.status === 201){
                    addToast({
                        mostrar: true,
                        titulo: 'Confirmación',
                        tipo: 'Success',
                        mensaje: response.data.message,
                    });
                    setShowFormModal(false);
                    setKey(key + 1);
                }
            }
        else {
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: 'Complete los campos del formulario para continuar',
            });
        }      
    }

    const onDelete = (id?: number | null) => {
        if (id){
            setModalConfirmacion({
                show: true,
                title: 'Eliminar tabla de desarrollo',
                message: "¿Está seguro de que quiere eliminar la tabla de desarrollo seleccionada?",
                metodo: () => {onDeleteConfirm(id)}
            });
        }
    }

    const onDeleteConfirm = async (id: number) => {
        const response = await eliminarTabla(id);
        if (response.status === 204 || response.status === 201){
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: `Se ha eliminado correctamente la tabla de desarrollo`,
            });
            setKey(key + 1);
        }
    }

    const onDetalle = async (id?: number | null) => {
        if (id){
            navigate('/maestros/tabla-desarrollo/detalle', { state: {idTablaDesarrollo: id}})
        }
    }

    const [showFormModal, setShowFormModal] = useState<boolean>(false);
    const [tablaSeleccionada, setTablaSeleccionada] = useState<FormularioTablaDesarrolloDto | null>(null);
    const [key, setKey] = useState<number>(0);

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    })

    return (
        <Suspense>
            <Breadcrumb items={breadcrumbItems} />
            <Box sx={{ mt: 2 }}>
                <ModalGeneracionTablaDesarrollo
                    show={showFormModal}
                    onHide={() => {setShowFormModal(false)}}
                    formularioDefecto={tablaSeleccionada}
                    watchParentForm={null}
                    onCreate={onCreate}
                    onUpdate={onUpdateConfirm}
                    idMutuo={null}
                    asignarACuotaMinima={null}
                />
                <ConfirmationModal
                    onHide={() =>
                        setModalConfirmacion({ ...modalConfirmacion, show: false })
                    }
                    onConfirm={modalConfirmacion.metodo}
                    title={modalConfirmacion.title}
                    show={modalConfirmacion.show}
                    message={modalConfirmacion.message}
                />
                <Paper elevation={3} sx={{ p: 3 }}>
                    <FormularioBusquedaTablaDesarrollo 
                        clickLupaCuotaMaxima={false}
                        clickLupaCuotaMinima={false}
                        isActionable={true}
                        onHide={() => {}}
                        setTablaSeleccionada={() => {}}
                        watchParentForm={undefined}
                        onUpdate={onUpdate}
                        onDelete={onDelete}
                        onDetalle={onDetalle}
                        onCreate={() => {
                            setTablaSeleccionada(null);
                            setShowFormModal(true)}
                        }
                        onImport={() => {
                            navigate('/maestros/tabla-desarrollo/importar')
                        }}
                        key={key}
                        onRestart={() => {}}
                    />
                </Paper>
            </Box>      
        </Suspense>
    )
}